module.exports = __webpack_public_path__ + "img/d251a6b42d0d3e45e2f69192b31b8b3f.svg";